export type Country = { code: string; dial: string; name: string }

export const DEFAULT_COUNTRY: Country = { code: 'ma', dial: '+212', name: 'Maroc' }
export const COUNTRIES: Country[] = [
  DEFAULT_COUNTRY,
  { code: 'fr', dial: '+33', name: 'France' },
  { code: 'be', dial: '+32', name: 'Belgique' },
  { code: 'ch', dial: '+41', name: 'Suisse' },
  { code: 'ca', dial: '+1', name: 'Canada' },
  { code: 'dz', dial: '+213', name: 'Algérie' },
  { code: 'tn', dial: '+216', name: 'Tunisie' },
  { code: 'sn', dial: '+221', name: 'Sénégal' },
  { code: 'ci', dial: '+225', name: "Côte d'Ivoire" },
  { code: 'ae', dial: '+971', name: 'Émirats' },
  { code: 'sa', dial: '+966', name: 'Arabie Saoudite' },
  { code: 'us', dial: '+1', name: 'États-Unis' },
  { code: 'gb', dial: '+44', name: 'Royaume-Uni' },
  { code: 'de', dial: '+49', name: 'Allemagne' },
  { code: 'es', dial: '+34', name: 'Espagne' },
  { code: 'it', dial: '+39', name: 'Italie' },
  { code: 'nl', dial: '+31', name: 'Pays-Bas' },
]

export function normalizePhone(value: string, dial: string) {
  if (value.trim().startsWith('+')) return `+${value.replace(/\D/g, '')}`
  const digits = value.replace(/\D/g, '').replace(/^0+/, '')
  const dialDigits = dial.replace(/\D/g, '')
  return digits.startsWith(dialDigits) ? `+${digits}` : `${dial}${digits}`
}

export function isValidPhone(value: string, dial: string) {
  return normalizePhone(value, dial).replace(/\D/g, '').length >= 11
}
